import CloseIcon from "@mui/icons-material/Close";
import FormControl from "@mui/material/FormControl";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import InputLabel from "@mui/material/InputLabel";
import OutlinedInput from "@mui/material/OutlinedInput";
import Tooltip from "@mui/material/Tooltip";
import { useContext, useEffect, useRef, useState } from "react";
import { InfoCircle } from "react-bootstrap-icons";
import "../../../../Tooltip/styles/tooltip.css";
import { DashboardContext } from "../../../DashboardContext/DashboardContextProvider.jsx";
import { FormContext } from "../context/FormProvider.jsx";
import * as Messages from "../messages/messages.js";
import "../styles/form-container.css";
import "./styles/new-text.css";
// import "./styles/text-field.css";

// TextField component is used to render a text input field in the form (Names, Addresses, etc.)
const ParcelNumbersField = ({
  idProp,
  label,
  req,
  slide9,
  state,
  setState,
  disabledInput,
  invalidData,
}) => {
  const textRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [openHelper, setOpenHelper] = useState(false);
  const [adjustMargin, setAdjustMargin] = useState(false);
  const { requestStatus, handleInputFocus, handleInputDisable } =
    useContext(FormContext);
  const { userId, formatParcelNumber } = useContext(DashboardContext);

  useEffect(() => {
    if (req && openHelper) {
      setAdjustMargin(true);
    } else {
      setAdjustMargin(false);
    }
  }, [req, openHelper]);

  // Function to handle text input change
  const handleTextChange = (e) => {
    let formattedValue = formatParcelNumber(e.target.value);
    setState(formattedValue);
  };

  return (
    <div className="text-info-container parcelNumber-info-container">
      <FormControl
        variant="outlined"
        id="text-form"
        classes={{ root: "form-text-root" }}
        className={`parcelNumber-form-control ${
          requestStatus === "RV" &&
          disabledInput === false &&
          invalidData &&
          (state === invalidData["initialValue"] || state === "")
            ? "revise-input"
            : requestStatus === "RV" &&
                disabledInput === false &&
                invalidData &&
                state !== invalidData["initialValue"] &&
                state !== ""
              ? "revised-input"
              : handleInputDisable(idProp, slide9, disabledInput, userId) ===
                  true
                ? "disable-text"
                : req
                  ? "required"
                  : ""
        }`}
      >
        <InputLabel
          id="text-field-label"
          htmlFor="text-input"
          classes={{ shrink: "text-field-label-shrink" }}
          className={`${idProp}-text-field-label`}
        >
          {`Add a ${label}`}
        </InputLabel>
        <OutlinedInput
          type="text"
          id="text-field"
          className={`parcelNumber-input`}
          ref={textRef}
          label={`Add ${label}`}
          value={state}
          onChange={handleTextChange}
          onFocus={() => handleInputFocus(textRef, setOpenHelper)}
          onSelect={() => {
            if (state === "") {
              setOpen(true);
            } else {
              setOpen(false);
            }
            setOpenHelper(true);
          }}
          onBlur={() => {
            setOpen(false);
            setOpenHelper(false);
          }}
          disabled={
            handleInputDisable(idProp, slide9, disabledInput, userId) === true
              ? true
              : false
          }
          autoComplete="off"
          autoCapitalize="words"
          classes={{
            root: "text-field-root",
            notchedOutline: "text-notchedOutline",
            input: "text-field-input",
          }}
          endAdornment={
            <Tooltip
              id="clear-btn-tooltip"
              classes={{
                tooltip: "tooltip-clear-btn",
                popper: "popper-clear-btn",
                tooltipPlacementTop: "tooltip-top",
              }}
              title={state === "" ? "" : "Clear Field"}
              placement="top"
            >
              <InputAdornment
                className="text-field-clear-adornment"
                id="text-adornment"
                position="end"
                style={
                  state === "" ||
                  handleInputDisable(idProp, slide9, disabledInput, userId) ===
                    true
                    ? { visibility: "hidden" }
                    : { visibility: "visible" }
                }
              >
                <IconButton
                  style={
                    state === ""
                      ? {
                          pointerEvents: "none",
                          cursor: "default",
                        }
                      : {
                          pointerEvents: "auto",
                          cursor: "pointer",
                        }
                  }
                  aria-label="clear input field"
                  onClick={() => {
                    setState("");
                  }}
                  onMouseDown={(e) => e.preventDefault()}
                  edge="end"
                  id="clear-icon-button"
                  disabled={state === "" ? true : false}
                >
                  <CloseIcon className="close-icon" />
                </IconButton>
              </InputAdornment>
            </Tooltip>
          }
        />
      </FormControl>
      <Tooltip
        id="tf-tooltip"
        classes={{
          tooltip: "text-field-tooltip",
          popper: "text-field-popper",
          arrow: "text-field-arrow",
          tooltipPlacementLeft: "text-field-right",
        }}
        title={Messages[`${idProp}Message`]}
        placement={"right"}
        arrow
        open={open}
        sx={{
          backgroundColor: "rgb(0, 0, 0, 0.8) !important",
        }}
      >
        <InfoCircle
          className="text-info-circ"
          id={`info-${idProp}`}
          color="white"
          size={30}
          onMouseEnter={() => setOpen(true)}
          onMouseLeave={() => setOpen(false)}
        />
      </Tooltip>
    </div>
  );
};
export default ParcelNumbersField;
